module.exports = __webpack_public_path__ + "img/B6.774ea911.png";